import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=06d954b4&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=ts"
export * from "./MemberCard.vue?vue&type=script&lang=ts"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=06d954b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d954b4",
  null
  
)

export default component.exports